export default __webpack_public_path__ + "static/media/tues-gray.993abb7a.png";